export {default as default} from './Pagination'
